/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ReassignmentList { 
    /**
     * 主管改派案件 ProcessId
     */
    processInstanceId?: string;
    /**
     * 主管改派案件 TaskId
     */
    taskId?: string;
    /**
     * 被改派案件 ProcessId
     */
    reassigningProcessInstanceId?: string;
    /**
     * 被改派案件 ProcessDefinitionId
     */
    reassigningProcessDefinitionId?: string;
    /**
     * 被改派案件 ProcessDefKey
     */
    reassigningProcessDefKey?: string;
    /**
     * 被改派案件 作業別
     */
    operation?: string;
    /**
     * 被改派案件 TaskId
     */
    reassigningTaskId?: string;
    /**
     * 被改派案件 流程階段
     */
    workflowStage?: string;
    /**
     * 改派BPM案件 產生日期
     */
    createTime?: Date;
    /**
     * 被改派案件 UserNo
     */
    assignor?: string;
    /**
     * 被改派案件 UserName
     */
    assignorName?: string;
    /**
     * 被改派案件 SystemId
     */
    systemId?: number;
    /**
     * 被改派案件 SystemName
     */
    systemName?: string;
}